import app from '../../forum/app';
import ItemList from '../../common/utils/ItemList';
import GlobalDiscussionsSearchSource from './GlobalDiscussionsSearchSource';
import GlobalUsersSearchSource from './GlobalUsersSearchSource';
import GlobalPostsSearchSource from './GlobalPostsSearchSource';
import AbstractGlobalSearch from '../../common/components/AbstractGlobalSearch';
export default class GlobalSearch extends AbstractGlobalSearch {
  static initAttrs(attrs) {
    attrs.label = app.translator.trans('core.forum.header.search_placeholder', {}, true);
    attrs.a11yRoleLabel = app.translator.trans('core.forum.header.search_role_label', {}, true);
  }
  sourceItems() {
    const items = new ItemList();
    if (app.forum.attribute('canViewForum')) {
      items.add('discussions', new GlobalDiscussionsSearchSource());
      items.add('posts', new GlobalPostsSearchSource());
    }
    if (app.forum.attribute('canSearchUsers')) {
      items.add('users', new GlobalUsersSearchSource());
    }
    return items;
  }
}
flarum.reg.add('core', 'forum/components/GlobalSearch', GlobalSearch);